
import React from 'react';

const Notification = () => {
    return <div>notification</div>

}

export default Notification;